var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.692 16a.75.75 0 01.75.75V18h7.808a.75.75 0 010 1.5h-7.808v1.25a.75.75 0 01-1.5 0v-4a.75.75 0 01.75-.75zM8 18a.75.75 0 010 1.5H3.75a.75.75 0 010-1.5H8zM8 9.25a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0v-1.25h-3.5a.75.75 0 010-1.5h3.5V10A.75.75 0 018 9.25zM20.25 11.25a.75.75 0 010 1.5h-8.5a.75.75 0 010-1.5h8.5zM16 2.5a.75.75 0 01.75.75V4.5h3.5a.75.75 0 010 1.5h-3.5v1.25a.75.75 0 01-1.5 0v-4A.75.75 0 0116 2.5zM12.25 4.5a.75.75 0 010 1.5h-8.5a.75.75 0 010-1.5h8.5z",
    fill: "currentColor"
  })));
}
SvgFilter.displayName = 'Filter';
export default SvgFilter;